import AuthPage from '@/components/AuthPage.vue'
import Register from '@/views/auth/Register.vue'
import VerifyEmail from '@/views/auth/VerifyEmail.vue'
import { authPageData } from '@/data.js'
import { AUTHENTICATED_ROLES } from '../routeRoles'

export const authRoutes = [
	{
		path: '/auth',
		name: 'Auth',
		component: AuthPage,
		meta: { requiresAuth: false },
		props: authPageData,
	},
	{
		path: '/bitrix24-auth',
		name: 'Bitrix24Auth',
		component: () => import('@/views/Bitrix24AuthPage.vue'),
		meta: { requiresAuth: false, bitrix24Only: true },
	},
	{
		path: '/bitrix24-entry',
		name: 'Bitrix24Entry',
		component: () => import('@/views/Bitrix24Entry.vue'),
		meta: { requiresAuth: false, bitrix24Only: true },
	},
	{
		path: '/bitrix24-welcome',
		name: 'Bitrix24Welcome',
		component: () => import('@/views/Bitrix24Welcome.vue'),
		meta: { requiresAuth: true, bitrix24Only: true },
	},
	{
		path: '/bitrix24/video-player',
		name: 'BitrixVideoPlayer',
		component: () => import('@/views/BitrixVideoPlayer.vue'),
		meta: {
			requiresAuth: true,
			roles: AUTHENTICATED_ROLES,
			bitrix24Only: true,
			title: 'Видео',
		},
	},
	{
		path: '/verify-email',
		name: 'VerifyEmail',
		component: VerifyEmail,
		meta: { requiresAuth: false },
	},
	{
		path: '/register',
		name: 'Register',
		component: Register,
		meta: {
			requiresAuth: false,
			disableBodyZoom: true,
			title: 'Регистрация',
		},
	},
]
